import React from 'react';
import './Disclosures.css';

const Disclosures = () => {
  return (
    <main className="disclosures-page">
      <div className="disclosures-container">
        <div className="disclosures-header">
          <h1 className="main-title">MANDATORY PUBLIC DISCLOSURE</h1>
          <h2 className="appendix-title">Appendix - IX</h2>
          <h3 className="subtitle">Mandatory Public Disclosure</h3>
        </div>

        {/* A. GENERAL INFORMATION */}
        <section className="disclosure-section">
          <h2 className="section-title">A. GENERAL INFORMATION</h2>
          <table className="disclosure-table">
            <thead>
              <tr>
                <th>Sl. No.</th>
                <th>Information</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>01</td>
                <td>Name of The School</td>
                <td><strong>PRAGATI VIDYALAYA</strong></td>
              </tr>
              <tr>
                <td>02</td>
                <td>Affiliation No. (If Applicable)</td>
                <td>831401</td>
              </tr>
              <tr>
                <td>03</td>
                <td>School Code (If Applicable)</td>
                <td>47038</td>
              </tr>
              <tr>
                <td>04</td>
                <td>Complete Address With Pin Code</td>
                <td>SY.NO.203/4, NAGARAMGERE ROAD, NEAR BHUTAPPATEMPLE, CHALLAKERE, CHITRADURGA, KARNATAKA - 577522</td>
              </tr>
              <tr>
                <td>05</td>
                <td>Principal Name & Qualification</td>
                <td>Dr. CHITRA SUBRAMANIAN</td>
              </tr>
              <tr>
                <td>06</td>
                <td>School E-mail Id</td>
                <td><a href="mailto:pragnalkidz@gmail.com">pragnalkidz@gmail.com</a></td>
              </tr>
              <tr>
                <td>07</td>
                <td>Contact Details (Landline/Mobile)</td>
                <td>+91 9981515103</td>
              </tr>
            </tbody>
          </table>
        </section>

        {/* B. DOCUMENTS AND INFORMATION */}
        <section className="disclosure-section">
          <h2 className="section-title">B. DOCUMENTS AND INFORMATION</h2>
          <table className="disclosure-table">
            <thead>
              <tr>
                <th>Sl. No</th>
                <th>Documents/Information</th>
                <th>Upload Documents</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>01</td>
                <td>Copies of Affiliation/upgaradtion letter and recent extension of affiliation,if any</td>
                <td><a href={`${process.env.PUBLIC_URL}/images/Affiliation.pdf`} target="_blank" rel="noopener noreferrer" className="doc-link">View Document</a></td>
              </tr>
              <tr>
                <td>02</td>
                <td>Copies of Societies/trust/company registration/renewal certificate,as applicable</td>
                <td><a href={`${process.env.PUBLIC_URL}/images/TRUST DEED.pdf`} target="_blank" rel="noopener noreferrer" className="doc-link">View Document</a></td>
              </tr>
              <tr>
                <td>03</td>
                <td>Copy of No Objection Certificate (NOC) Issued, by The State Govt. /UT</td>
                <td><a href={`${process.env.PUBLIC_URL}/images/NOC.pdf`} target="_blank" rel="noopener noreferrer" className="doc-link">View Document</a></td>
              </tr>
              <tr>
                <td>04</td>
                <td>Copy of Recognition Certificate under RTE act, 2009 and it's renewal if applicable</td>
                <td><a href={`${process.env.PUBLIC_URL}/images/RR COPY_organized.pdf`} target="_blank" rel="noopener noreferrer" className="doc-link">View Document</a></td>
              </tr>
              <tr>
                <td>05</td>
                <td>Copy of Valid Building Safety Certificate As Per The National Building Code</td>
                <td><a href={`${process.env.PUBLIC_URL}/images/Building safety 2025-28.pdf`} target="_blank" rel="noopener noreferrer" className="doc-link">View Document</a></td>
              </tr>
              <tr>
                <td>06</td>
                <td>Copy of Valid Fire Safety Certificate Issued by The Competent Authority</td>
                <td><a href={`${process.env.PUBLIC_URL}/images/Fire_Safety.pdf`} target="_blank" rel="noopener noreferrer" className="doc-link">View Document</a></td>
              </tr>
              <tr>
                <td>07</td>
                <td>Copy of the self decleration submitted by the school for affiliation/upgradation/ extension of affiliation</td>
                <td><a href={`${process.env.PUBLIC_URL}/images/PRAGATI VIDYALAYA SELF CERTIFICATION.pdf`} target="_blank" rel="noopener noreferrer" className="doc-link">View Document</a></td>
              </tr>
              <tr>
                <td>08</td>
                <td>Copies of valid water,health and sanitation certificates</td>
                <td><a href={`${process.env.PUBLIC_URL}/images/DRINKING WATER.pdf`} target="_blank" rel="noopener noreferrer" className="doc-link">View Document</a></td>
              </tr>
            </tbody>
          </table>
        </section>

        {/* C. RESULT AND ACADEMICS */}
        <section className="disclosure-section">
          <h2 className="section-title">C. RESULT AND ACADEMICS</h2>
          <table className="disclosure-table">
            <thead>
              <tr>
                <th>Sl. No.</th>
                <th>Documents/ Information</th>
                <th>Upload Documents</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>01</td>
                <td>Fee Structure of The School</td>
                <td><a href={`${process.env.PUBLIC_URL}/images/fee-structure.pdf`} target="_blank" rel="noopener noreferrer" className="doc-link">View Document</a></td>
              </tr>
              <tr>
                <td>02</td>
                <td>Annual Academics Calendar</td>
                <td><a href={`${process.env.PUBLIC_URL}/images/ANNUAL CALENDAR 2025-26.pdf`} target="_blank" rel="noopener noreferrer" className="doc-link">View Document</a></td>
              </tr>
              <tr>
                <td>03</td>
                <td>List of School Management Committee (SMC)</td>
                <td><a href={`${process.env.PUBLIC_URL}/images/SMC committee.pdf`} target="_blank" rel="noopener noreferrer" className="doc-link">View Document</a></td>
              </tr>
              <tr>
                <td>04</td>
                <td>List of Parents Teachers Association (PTA) Members</td>
                <td><a href={`${process.env.PUBLIC_URL}/images/PTA.pdf`} target="_blank" rel="noopener noreferrer" className="doc-link">View Document</a></td>
              </tr>
              <tr>
                <td>05</td>
                <td>Infrastructure Details</td>
                <td><a href={`${process.env.PUBLIC_URL}/images/infra.pdf`} target="_blank" rel="noopener noreferrer" className="doc-link">View Document</a></td>
              </tr>
              <tr>
                <td>06</td>
                <td>Staff Statement Details</td>
                <td><a href={`${process.env.PUBLIC_URL}/images/staffstatemen.pdf`} target="_blank" rel="noopener noreferrer" className="doc-link">View Document</a></td>
              </tr>
              <tr>
                <td>07</td>
                <td>Last Three–Year Result of The Board Examination As Per Applicability</td>
                <td>NA</td>
              </tr>
            </tbody>
          </table>

          {/* RESULT CLASS X */}
          <div className="result-section">
            <h3 className="result-title">RESULT CLASS X</h3>
            <table className="disclosure-table result-table">
              <thead>
                <tr>
                  <th>Sl.No.</th>
                  <th>Year</th>
                  <th>No. of Registered Students</th>
                  <th>No. of Students Passed</th>
                  <th>Pass Percentage</th>
                  <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>NOT APPLICABLE</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* RESULT CLASS XII */}
          <div className="result-section">
            <h3 className="result-title">RESULT CLASS XII</h3>
            <table className="disclosure-table result-table">
              <thead>
                <tr>
                  <th>Sl.No.</th>
                  <th>Year</th>
                  <th>No. of Registered Students</th>
                  <th>No. of Students Passed</th>
                  <th>Pass Percentage</th>
                  <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>NOT APPLICABLE</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* D. STAFF (TEACHING) */}
        <section className="disclosure-section">
          <h2 className="section-title">D. STAFF (TEACHING)</h2>
          <table className="disclosure-table">
            <thead>
              <tr>
                <th>Sl. No.</th>
                <th>Information</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>01</td>
                <td>Principal</td>
                <td>Dr. CHITRA SUBRAMANIAN</td>
              </tr>
              <tr>
                <td>02</td>
                <td>Total No. of Teachers</td>
                <td>41</td>
              </tr>
              <tr className="nested-row">
                <td></td>
                <td>PGT</td>
                <td>4</td>
              </tr>
              <tr className="nested-row">
                <td></td>
                <td>PRT</td>
                <td>14</td>
              </tr>
              <tr className="nested-row">
                <td></td>
                <td>TGT</td>
                <td>10</td>
              </tr>
               <tr className="nested-row">
                <td></td>
                <td>NTTC</td>
                <td>2</td>
              </tr>
               <tr className="nested-row">
                <td></td>
                <td>Drawing</td>
                <td>2</td>
              </tr>
              <tr className="nested-row">
                <td></td>
                <td>Computers</td>
                <td>3</td>
              </tr>
              <tr className="nested-row">
                <td></td>
                <td>PET</td>
                <td>2</td>
              </tr>
              <tr className="nested-row">
                <td></td>
                <td>Music and Dance</td>
                <td>2</td>
              </tr>
              <tr className="nested-row">
                <td></td>
                <td>Librarian</td>
                <td>1</td>
              </tr>
              <tr>
                <td>03</td>
                <td>Teachers Section Ratio</td>
                <td>1:17</td>
              </tr>
              <tr>
                <td>04</td>
                <td>Details of Special Educators</td>
                <td>1</td>
              </tr>
              <tr>
                <td>05</td>
                <td>Details Of Counselling And Wellness Teacher</td>
                <td>1</td>
              </tr>
            </tbody>
          </table>
        </section>

        {/* E. SCHOOL INFRASTRUCTURE */}
        <section className="disclosure-section">
          <h2 className="section-title">E. SCHOOL INFRASTRUCTURE</h2>
          <table className="disclosure-table">
            <thead>
              <tr>
                <th>Sl. No.</th>
                <th>Information/Information</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>01</td>
                <td>Total Campus Area of The School(In Square Mtr)</td>
                <td>8295</td>
              </tr>
              <tr>
                <td>02</td>
                <td>No. and size of the class rooms(in sq mtr)</td>
                <td>20 & 48</td>
              </tr>
              <tr>
                <td>03</td>
                <td>No. and size of the laboratories including computer labs(in sq mtr)</td>
                <td>3 & 215</td>
              </tr>
              <tr>
                <td>04</td>
                <td>Internet Facility (Y/N)</td>
                <td>Yes</td>
              </tr>
              <tr>
                <td>05</td>
                <td>No. of Girls Toilets</td>
                <td>18</td>
              </tr>
              <tr>
                <td>06</td>
                <td>No. of Boys Toilets</td>
                <td>36</td>
              </tr>
              <tr>
                <td>07</td>
                <td>Link of Youtube Video of The Inspection of School Covering The Infrastructure of The School</td>
                <td><a href="https://youtu.be/sy2CLhLEi-U" target="_blank" rel="noopener noreferrer" className="doc-link">https://youtu.be/sy2CLhLEi-U</a></td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>
    </main>
  );
};

export default Disclosures;

